import './bootstrap';
import '../scss/global.scss';
import '../css/app.css';
import 'material-icons/iconfont/material-icons.css';

// import dark scheme variables for Element Plus
import 'element-plus/theme-chalk/dark/css-vars.css';

// Vue 3
import { createApp, h } from 'vue';

// Inertia.js
import { createInertiaApp, Link, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';

// Directives
import ClickOutside from '@/Directives/ClickOutsideDirective';

// Layouts
import DashboardLayout from '@/Layouts/DashboardLayout.vue';

// PrimeVue
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import 'primeicons/primeicons.css';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

// Globaler Handler für abgelaufene Sessions/CSRF
router.on('invalid', (event) => {
  if (event.detail.response.status === 419) {
    event.preventDefault()
    window.location.reload()
  }
})

createInertiaApp({
  title: (title) => `${title} - ${appName}`,
  resolve: (name) => {
    const page = resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'));

    page.then((module) => {
      module.default.layout = module.default.layout === undefined ? DashboardLayout : module.default.layout;
    });

    return page;
  },
  setup({ el, App, props, plugin }) {
    return createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(ZiggyVue, Ziggy)
      .use(PrimeVue, { theme: { preset: Aura, options: { darkModeSelector: '.dark' } } })
      .use(ConfirmationService)
      .use(ToastService)
      .component("Link", Link)
      .directive("click-outside", ClickOutside)
      .directive("tooltip", Tooltip)
      .mount(el);
  },
  progress: {
    color: 'var(--clr-company)',
  },
});
